import styled from "styled-components";
import { typographyMixin } from "../../typography";
import { TickerCardProps } from "./Ticker";

type StatusProps = Pick<TickerCardProps, "status">;

type CardProps = Pick<TickerCardProps, "status"> & {
  divisionText?: string;
};

type ArrowProps = {
  active: boolean;
};

type TeamProps = {
  loser: boolean;
};

export const StyledTickerContianer = styled.div.attrs({ className: "ticker-container" })`
  ${typographyMixin}
  background-color: #d7d7d8;
  height: 80px;
  max-height: 80px;
  display: flex;

  @media screen and (min-width: 769px) {
    height: 90px;
    max-height: 90px;
  }
`;

export const StyledCardsContainer = styled.div.attrs({ className: "cards-container" })`
  ${typographyMixin}
  background-color: #d7d7d8;
  height: 80px;
  max-height: 80px;
  display: flex;
  overflow-x: hidden;
  width: 100%;
  @media screen and (min-width: 769px) {
    height: 90px;
    max-height: 90px;
  }
`;

export const StyledNoGames = styled.div.attrs({ className: "no-games" })`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  color: #36383d;
  text-align: center;
  font-size: 1.125rem;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  text-transform: capitalize;
`;

export const LogoContainer = styled.div.attrs({ className: "gs-logo-container" })`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #36383d;
  text-align: center;
  font-family: Kapra Neue Pro;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: uppercase;
  margin: 0.5rem;
`;

export const StyledTickerTeam = styled.div.attrs({ className: "ticker-team" })`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledTeamInfoContainer = styled.div.attrs({ className: "team-info-container" })`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const StyledTickerTitle = styled.div.attrs({ className: "ticker-title" })<TeamProps>`
  color: ${({ loser }) => (loser ? "#86888B" : "#36383d")};
  font-size: 0.625rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  @media screen and (min-width: 769px) {
    font-size: 0.75rem;
  }
`;

export const StyledTickerScore = styled.div.attrs({ className: "ticker-score" })<TeamProps>`
  color: ${({ loser }) => (loser ? "#86888B" : "#36383d")};
  text-align: center;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: uppercase;
  padding-right: 0.25rem;

  @media screen and (min-width: 769px) {
    font-size: 0.875rem;
  }
`;

export const StyledTeamImg = styled.img.attrs({ className: "ticker-team-img" })`
  width: 1.1rem;
  flex-shrink: 0;
  @media screen and (min-width: 769px) {
    width: 1.25rem;
  }
`;

export const StyledTickerCard = styled.div.attrs(() => ({
  className: "ticker-card",
}))<CardProps>`
  display: flex;
  position: relative;
  justify-content: space-between;
  align-items: center;
  border-radius: 0.3125rem;
  background: #fff;
  padding: ${({ divisionText }) => (divisionText ? ".75rem 0.25rem 0rem 0.25rem" : "0.25rem 0.25rem")};
  margin: 0.25rem 0.25rem 0.25rem 0;
  border-bottom: ${({ status }) => (status === "live" ? "3px solid #306cf6" : "none")};

  @media screen and (min-width: 769px) {
    border-bottom: ${({ status }) => (status === "live" ? "4px solid #306cf6" : "none")};
  }
`;

export const StyledDivisionBanner = styled.div.attrs({ className: "division-banner" })`
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 0.3125rem 0.3125rem 0rem 0rem;
  background: #afafb1;
  color: #fff;
  font-size: 0.40625rem;
  font-style: normal;
  font-weight: 400;
  text-transform: capitalize;
  width: 100%;
  max-height: 0.75rem;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 0.25rem;

  @media screen and (min-width: 769px) {
    font-size: 0.5rem;
  }
`;

export const StyledTeamsContainer = styled.div.attrs({ className: "ticker-teams-container" })`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 100%;
  height: 100%;
  min-width: 9rem;
  max-width: 9rem;
  @media screen and (min-width: 769px) {
    min-width: 10rem;
    max-width: 10rem;
  }
`;

export const StyledCardStatus = styled.div.attrs(() => ({
  className: "ticker-card-status",
}))<StatusProps>`
  color: ${({ status }) => (status === "live" ? "#306cf6" : "#36383d")};
  font-family: ${({ status }) => (status === "scheduled" ? "Kapra Neue Pro" : "Rubik")};
  text-align: center;
  font-size: ${({ status }) => (status === "scheduled" ? "0.875rem" : "0.625rem")};
  white-space: ${({ status }) => (status === "scheduled" ? "nowrap" : "normal")};
  font-style: normal;
  font-weight: 500;
  line-height: 1.5;
  text-transform: uppercase;
  padding-bottom: 0.25rem;

  @media screen and (min-width: 769px) {
    font-size: ${({ status }) => (status === "scheduled" ? "1.125rem" : ".75rem")};

    padding-bottom: 0.5rem;
    padding-left: 0.5rem;
  }
`;

export const StyledTickerHeader = styled.div.attrs({ className: "ticker-header" })`
  border-bottom-left-radius: 0.3125rem;
  border-top-left-radius: 0.3125rem;
  margin: 0.25rem -0.25rem 0.25rem 0rem;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 0.625rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: uppercase;
  padding: 0.25rem 0.75rem 0.25rem 0.5rem;
  background-color: ${(props) => props.theme.secondaryColor};
  color: ${(props) => props.theme.textOnSecondaryColor};
`;

export const StyledArrow = styled.div.attrs({ className: "ticker-arrow" })<ArrowProps>`
  width: 1.43944rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 0.5rem;
  border-radius: 0.3125rem;
  margin: 0.25rem;
  background-color: ${(props) => (props.active ? props.theme.primaryColor : "#AFAFB1")};
  cursor: ${(props) => (props.active ? "pointer" : "default")};

  @media screen and (min-width: 769px) {
    width: 1.83206rem;
    margin: 0.25rem 0.25rem;
  }
`;
